var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emap-flow-select-m" },
    [
      _c("van-cell", {
        attrs: {
          title: _vm.label,
          "is-link": !_vm.disabled,
          value: _vm.display,
          required: _vm.required,
          "value-class": _vm.valueClass,
          "title-style": "flex: 0 0 90px",
        },
        on: { click: _vm.handleSelect },
        scopedSlots: _vm._u([
          {
            key: "right-icon",
            fn: function () {
              return [
                !_vm.loading && !_vm.disabled
                  ? _c("van-icon", {
                      staticClass: "van-cell__right-icon",
                      attrs: { name: "arrow" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.loading && !_vm.disabled
                  ? _c("van-loading", {
                      attrs: { type: "spinner", size: "24px" },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.popup,
            callback: function ($$v) {
              _vm.popup = $$v
            },
            expression: "popup",
          },
        },
        [
          _c(
            "div",
            { staticClass: "van-hairline--top-bottom van-picker__toolbar" },
            [
              _c(
                "button",
                {
                  staticClass: "van-picker__cancel",
                  attrs: { type: "button" },
                  on: { click: _vm.handleCancel },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "van-picker__confirm",
                  attrs: { type: "button" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("确认")]
              ),
            ]
          ),
          _vm._v(" "),
          _c("atom-" + _vm.type, {
            ref: _vm.type,
            tag: "component",
            attrs: {
              options: _vm.options,
              "value-key": _vm.valueKey,
              "label-key": _vm.labelKey,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }